import { render, staticRenderFns } from "./MoleculeEditionAcademyAutorespondersModalDelete.vue?vue&type=template&id=3b5c7c63&"
import script from "./MoleculeEditionAcademyAutorespondersModalDelete.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyAutorespondersModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports